import "bootstrap";
import { Swiper, Autoplay, Navigation } from "swiper";

Swiper.use([Autoplay, Navigation]);
window.Swiper = Swiper;

window.getWindowSize = function () {
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    };
};

// ------------------------------------------------------- //
// Multi Level Dropdown
// ------------------------------------------------------ //

jQuery(function ($) {
    $("ul.dropdown-menu [data-toggle='dropdown']").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        $(this).siblings().toggleClass("show");

        if (!$(this).next().hasClass("show")) {
            $(this)
                .parents(".dropdown-menu")
                .first()
                .find(".show")
                .removeClass("show");
        }
        $(this)
            .parents("li.nav-item.dropdown.show")
            .on("hidden.bs.dropdown", function (e) {
                $(".dropdown-submenu .show").removeClass("show");
            });
    });
});
